module.exports = __webpack_public_path__ + "img/1F55E.066690f8.svg";